export default {
  'permissions.admin': 'Администратор',
  'permissions.developer': 'Разработчик',
  'permissions.methodologist': 'Методолог',
  'permissions.user': 'Пользователь',
  'permissions.current': 'Разрешения позиции',
  'permissions.none': 'Бэкенд пока не передаёт разрешения',
  'permissions.sections': 'Доступные разделы',
  'permissions.sections.all': 'Все разделы',
  'permissions.preview.label': 'Посмотреть интерфейс под другие разрешения',
  'permissions.preview.actual': 'Как в профиле',
  'permissions.preview.hint':
    'Меняет только раскладку интерфейса на этом устройстве. Токен и проверки на сервере остаются прежними.',
  'permissions.preview.active':
    'Интерфейс собран по выбранным разрешениям. С бэкенда пришло: {actual}.',
  'permissions.welcome.frameTitle': 'Доступ и интерфейс',
};
